import React from 'react';
import Hdr from './shared/Hdr';
import Progress from './Progress';
import { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function DiagFAQ() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayFAQ, setDisplayFAQ] = useState('none');
  const [displayUpdFAQ, setDisplayUpdFAQ] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [verfied, setVerfied] = useState(true);
  const [updQuestion, setUpdQuestion] = useState('');
  const [id, setID] = useState('');
  //  const [Err, SetErr] = useState([]);

  const handleSubmit = () => {
    verifyFAQ()
    if (verfied) {
      formRef.current.reset();
    }
  }

  const formRef = useRef();
  const [question, setQuestion] = useState('');
  const [DiagnosticDataStat, setDiagnosticDataStat] = useState('')
  const [answer, setAnswer] = useState('');
  const [DiagnosticData, setDiagnosticData] = useState([])
  const [updDiagnosticId, setUpdDiagnosticId] = useState()
  const [updAnswer, setUpdAnswer] = useState()
  const [defaultDiagnostic, setDefaultDiagnostic] = useState()
  const [isloading, setIsLoading] = useState(false)
  const [IsDisabled, setIsDisabled] = useState(false)
  const [filteredID, setFilteredId] = useState()

  let txt = "";

  useEffect(() => {
    getDiagnostic()
    getFAQ(defaultDiagnostic)
  }, [])

  function openFAQ() {
    setDisplayFAQ('block')
  }

  function closeFAQ() {
    formRef.current.reset();
    setDisplayFAQ('none')
  }

  function openUpdFAQ() {
    setDisplayUpdFAQ('block')
  }

  function closeUpdFAQ() {
    setDisplayUpdFAQ('none')
  }

  async function updateFAQ(id, updDiagnosticId) {

    setIsLoading(true)
    let result = await fetch(apiPath + "updateDiagFaq", {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "diag_id": updDiagnosticId,
        "question": updQuestion,
        "answer": updAnswer
      })
    });

    result = await result.json();

    showSwal(result.success, result.message)
    getFAQ(filteredID)
    if (isloading) {
    } else {
      setIsLoading(false)
    }
  }

  async function deleteFAQ(id, sp_id) {

    let result = await fetch(apiPath + "deleteDiagFaq/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getFAQ(filteredID)
  }

  async function updateOperation(id) {

    let result = await fetch(apiPath + "getOneDiagFaq/" + id,

      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",

          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUpdDiagnosticId(result.data[0].diag_id)
    setUpdQuestion(result.data[0].question);
    setUpdAnswer(result.data[0].answer)
    setID(result.data[0].id)

    openUpdFAQ();
  }


  function deleteOperation(id, sp_id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteFAQ(id, sp_id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }

  //* LIST OF ALL TESTIMONIALS (for initial screen)*/ 

  async function getFAQ(id) {
    //  alert(id)
    let result = await fetch(apiPath + "getDiagFaq/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  function verifyFAQ() {
    setVerfied(true)
    addFAQ()
  }

  //*ADD A NEW FAQ*/ 
  async function addFAQ() {
    //    alert('Add,'+departmentName)
    if (verfied) {
      setIsDisabled(true)
      setIsLoading(true)

      let result = await fetch(apiPath + "storeDiagFaq", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "diag_id": filteredID,
          "question": question,
          "answer": answer
        })

      });
      result = await result.json();

      //  if (result.success) { }
      //  else {
      //    SetErr(result.data);
      //  }

      setIsDisabled(false)

      showSwal(result.success, result.message)
      getFAQ(filteredID)

      if (isloading) {
      } else {
        setIsLoading(false)
      }
    }
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  /* LIST OF ALL Diagnostic (for combo)*/

  async function getDiagnostic() {
    let result2 = await fetch(apiPath + "diagnostics",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result2 = await result2.json();
    setDiagnosticDataStat(result2.success);


    if (result2.success === true) {
      setDiagnosticData(result2.data);
      //   alert(result2.data.id)
      setDefaultDiagnostic(result2.data[0].id)
    } else { setDiagnosticData([]) }
  }


  function FilterData(id) {
    getFAQ(id)
    setFilteredId(id)
  }


  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Frequently Asked Questions : Diagnostic......</h4>
            </div>
            <div className="c12-l-5"></div>
            <div className="c12-l-2">
              <select className="custom-select" onChange={(e) => FilterData(e.target.value)} >
                {
                  (DiagnosticDataStat === true ?
                    (
                      DiagnosticData.map((item2, index) =>
                        <option value={item2.id} >{item2.name}</option>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </select>
            </div>
            <div className="c12-l-2">
              <button onClick={openFAQ} type="button" name="button"
                className="btn solid round">Create New FAQ</button>
            </div>
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="15%">Id</th>
                  <th className="th-border left" width="30%">Questions</th>
                  <th className="th-border left" width="55%">Answars</th>
                  <th className="th-border left" width="10%">Edit</th>
                  <th className="th-border left" width="10%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>

                          <td className="left">{item.question}</td>
                          <td className="left">{item.answer}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.id, { filteredID }) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW FAQ */}

          <div id="newdept" style={{ 'display': displayFAQ }} className="cont__new-dept">
            <form className="" action="" method="" ref={formRef}>
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeFAQ}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add FAQ</h2>
                  <br></br>

                  <input type="hidden" value={id} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Question" onChange={(e) => setQuestion(e.target.value)} />

                  <textarea className="box small" autoComplete="off" rows='10'
                    placeholder="Answer" onChange={(e) => setAnswer(e.target.value)} />

                  <br></br>
                  <button disabled={IsDisabled} onClick={handleSubmit} type="button"
                    className="btn solid round">Add FAQ</button>

                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }

                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING FAQ */}

          <div id="newdept" style={{ 'display': displayUpdFAQ }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdFAQ}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit FAQ</h2><br /><br />

                  <input type="hidden" value={id} />
                  <input type="text" value={updDiagnosticId} />

                  <input type="text" className="box small"
                    placeholder="Question" onChange={(e) => setUpdQuestion(e.target.value)}
                    value={updQuestion} />

                  <input type="text" className="box small"
                    placeholder="Answer" onChange={(e) => setUpdAnswer(e.target.value)}
                    value={updAnswer} />

                  <br></br>
                  <button onClick={() => { updateFAQ(id, updDiagnosticId) }} type="button"
                    className="btn solid round">Update FAQ</button>
                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiagFAQ;
